import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_GROUP_NOTE_DETAILS,
    CLEAR_GROUP_NOTE_DETAILS_ERROR,
    LOAD_GROUP_NOTE_DETAILS_REQUEST,
    LOAD_GROUP_NOTE_DETAILS_SUCCESS,
    LOAD_GROUP_NOTE_DETAILS_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_GROUP_NOTE_DETAILS,
    CLEAR_ERROR: CLEAR_GROUP_NOTE_DETAILS_ERROR,
    LOAD_REQUEST: LOAD_GROUP_NOTE_DETAILS_REQUEST,
    LOAD_SUCCESS: LOAD_GROUP_NOTE_DETAILS_SUCCESS,
    LOAD_FAILURE: LOAD_GROUP_NOTE_DETAILS_FAILURE
}